export default __webpack_public_path__ + "static/media/qualitas.5d181e22.png";